import Tabs from '@/components/Tabs/Tabs';
import styles from './TutorialDetail.module.less';
import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { projectController } from '@/api';
import { useSelector } from 'react-redux';
import tutorialList from '@/utils/tutorial';
export default function Home() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState(tutorialList);
  const [item, setItem] = useState(
    tutorialList.find((item) => {
      return item.id == id;
    }),
  );

  useEffect(() => {}, []);

  return (
    <div className={styles.container}>
      <div className={styles.bread}>Tutorial &gt; {item.title}</div>
      <div className={styles.title}>{item.title}</div>
      <div className={styles.subtitle}>{item.subTitle}</div>
      <div className={styles.coverimgWrapper}>
        <img className={styles.coverimg} src={item.image}></img>
      </div>
      <div className={styles.content}>{item.content}</div>
    </div>
  );
}
